import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {TabFormat} from "../../../modals/types/tab";
import "./normaltab.scss";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function NormalTab({tabs, tabPanel}: TabFormat) {
    const [value, setValue] = React.useState(0);

    //@ts-ignore
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box className="Normal-Tab" sx={{width: '100%'}}>
            <Tabs className="Normal-Tab-Tabs" value={value} onChange={handleChange} centered
                  aria-label="basic tabs example">
                {
                    tabs.map((tab, index) => {
                        return (
                            <Tab key={index} label={tab} {...a11yProps(index)}/>
                        );
                    })
                }
            </Tabs>
            {
                tabPanel.map((option, index) => {
                    return (
                        <TabPanel key={index} value={value} index={index}>
                            {option}
                        </TabPanel>
                    );
                })
            }
        </Box>
    );
}
